
export const act_LoadPlans = (payload) => ({ type:'LOAD_PLANS', payload })

export const act_LoadPlan = (payload) => ({ type:'LOAD_PLAN', payload })

export const act_LoadTempPlan = (payload) => ({ type:'LOAD_TEMP_PLAN', payload })

export const act_ToggleTreeItem = (payload) => ({ type:'TOGGLE_TREE_ITEM', payload })